export default function categories(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                category: action.category,
            }
        default:
            return state;
    }
}
